<template>
  <div class="container-fluid default-dashboard">
    <div class="col-12">
      <div class="row">
        <div class="col-md-3">
          <WelcomeView />
        </div>
        <div class="col-md-9">
          <div class="row general-widget">
            <div class="card-body px-0 pb-0">
              <div class="tab-content">
                <div v-show="activeTab === 'reservation'" class="tab-pane fade justify-content-start show active"
                  id="reservation-panel" role="tabpanel" aria-labelledby="reservation-panel-tab"
                  key="reservation-panel-tab">
                  <div class="row">
                    <Card1 colClass="col-sm-6 col-xl-3 box-col-6 py-0" cardClass="card widget-1 py-0"
                      v-for="(item, index) in widgetsReservation" :key="`reservation-${index}`">
                      <div class="widget-content">
                        <div class="widget-round " :class="item.class">
                          <div class="bg-round">
                            <h4>{{ item.number }}</h4>
                          </div>
                        </div>
                        <div class="col-12">
                          <span class="f-light">{{ item.title }}</span>
                        </div>
                      </div>
                    </Card1>
                  </div>
                </div>
                <div v-show="activeTab === 'registration'" class="tab-pane fade justify-content-center"
                  id="registration-panel" role="tabpanel" aria-labelledby="registration-panel-tab"
                  key="registration-panel-tab">
                  <div class="row">
                    <Card1 colClass="col-sm-6 col-xl-3 box-col-6 py-0" cardClass="card widget-1 py-0"
                      v-for="(item, index) in widgetsRegistration" :key="`registration-${index}`">
                      <div class="widget-content">
                        <div class="widget-round " :class="item.class">
                          <div class="bg-round">
                            <h4>{{ item.number }}</h4>
                          </div>
                        </div>
                        <div class="col-12">
                          <span class="f-light">{{ item.title }}</span>
                        </div>
                      </div>
                    </Card1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="card">
              <div class="row card-body">
                <div class="card-header d-flex justify-content-start align-items-center flex-wrap gap-2 pb-2 p-0">
                  <ul class="nav nav-pills nav-primary" id="j-pills-tab" role="tablist">
                    <li class="nav-item"><a :class="['nav-link', { active: activeTab === 'reservation' }]"
                        id="reservation-panel-tab" data-bs-toggle="pill" href="#reservation-panel" role="tab"
                        aria-controls="reservation-panel" :aria-selected="activeTab === 'reservation'"
                        @click="handleTabChange('reservation')">
                        Reservasi</a></li>
                    <li class="nav-item"><a :class="['nav-link', { active: activeTab === 'registration' }]"
                        id="registration-panel-tab" data-bs-toggle="pill" href="#registration-panel" role="tab"
                        aria-controls="registration-panel" :aria-selected="activeTab === 'registration'"
                        @click="handleTabChange('registration')">
                        Registrasi</a></li>
                  </ul>
                </div>

                <div class="card-body px-0 pb-0">
                  <div class="tab-content">
                    <div v-show="activeTab === 'reservation'" class="tab-pane fade justify-content-start show active"
                      id="reservation-panel" role="tabpanel" aria-labelledby="reservation-panel-tab"
                      key="reservation-panel-tab">
                      <div class="col-12 box-col-10">
                          <div class="calendar-default" id="calendar-container-reservation">
                            <div id="calendar-reservation">
                              <FullCalendar id="FullCalendarReservation" ref="fullCalendarReservation"
                                :options="calendarReservationOptions" />
                            </div>
                          </div>
                      </div>
                    </div>
                    <div v-show="activeTab === 'registration'" class="tab-pane fade justify-content-start show active"  
                      id="registration-panel" role="tabpanel" aria-labelledby="registration-panel-tab"
                      key="registration-panel-tab">
                      <div class="col-12 box-col-10">
                          <div class="calendar-default" id="calendar-container-registration">
                            <div id="calendar-registration">
                              <FullCalendar id="FullCalendarRegistration" ref="fullCalendarRegistration"
                                :options="calendarRegistrationOptions" />
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, defineAsyncComponent, watch, nextTick } from 'vue'
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const role = session.getUser().role
const clinics = session.getUser().clinic

// Interface untuk widget data
interface WidgetData {
  class: string;
  svg1: string;
  svg2: string;
  number: number;
  title: string;
  font: string;
  icon: string;
  total: string;
}

import * as clinic from "@/api/services/ClinicRequest";
const widgetsReservation = ref<WidgetData[]>([])
const widgetsRegistration = ref<WidgetData[]>([])

const WelcomeView = defineAsyncComponent(() => import("@/components/widget/card/WelcomeView.vue"))
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))


const lastSelectedInfoReservation = ref("")
const lastSelectedInfoRegistration = ref("")

// State management untuk tab aktif
const activeTab = ref<'reservation' | 'registration'>('reservation')

const fullCalendarReservation = ref<any>(null);
const fullCalendarRegistration = ref<any>(null);
const daySelectedReservation = ref<string>('');
const daySelectedRegistration = ref<string>('');
const reservationData = reactive<any>([])
const registrationData = reactive<any>([])

const listReservation = ref<any>([])
const listRegistration = ref<any>([])
const loading = ref(false)

// Function untuk handle tab change
const handleTabChange = (tabName: 'reservation' | 'registration') => {
  activeTab.value = tabName

  // Refresh calendar data saat tab berubah dengan delay untuk memastikan DOM sudah terupdate
  nextTick(() => {
    if (tabName === 'reservation' && fullCalendarReservation.value) {
      // fullCalendarReservation.value.getApi().refetchEvents()
      fullCalendarRegistration.value.getApi().updateSize()
    } else if (tabName === 'registration' && fullCalendarRegistration.value) {
      // fullCalendarRegistration.value.getApi().refetchEvents()
      fullCalendarRegistration.value.getApi().updateSize()
    }
  })
}

const calendarRegistrationOptions = {
  plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
  initialView: "dayGridMonth",
  editable: false, selectable: true,
  selectMirror: true, dayMaxEvents: true, weekends: true,
  select: handleDateSelectRegistration,
  droppable: false,
  headerToolbar: {
    left: "prev,next", center: "title", right: "dayGridMonth",
  },
  events: async function (fetchInfo: any, successCallback: any, failureCallback: any) {
    let list = [] as any
    loading.value = true
    widgetsRegistration.value = []

    try {
      const response = await clinic.postRequest("/registration/calendar", {
        start_date: fetchInfo.startStr,
        end_date: fetchInfo.endStr,
        clinic: clinics
      })

      if (response.status == 200 && response.data && Array.isArray(response.data)) {
        list = response.data.map((item: any) => {
          return {
            id: item.ID || item.id,
            title: ` (${item.total || 0}) ${item.status || 'Unknown'}`,
            start: new Date(item.date).toISOString(),
            allDay: true
          }
        })

        widgetsRegistration.value = Object.values(response.data.reduce((acc: any, item: any) => {
          const status = item.status || 'Unknown'
          if (!acc[status]) {
            acc[status] = {
              class: "success",
              svg1: "rate",
              svg2: "halfcircle",
              number: 0,
              title: status,
              font: "font-success",
              icon: "icon-arrow-up",
              total: "+70%"
            };
          }
          acc[status].number += item.total || 0;
          return acc;
        }, {}));

      }
    } catch (error) {
      console.error('Error fetching registration calendar data, using mock data:', error)
      failureCallback(error)
    };

    loading.value = false
    successCallback(list);
  }
}

const calendarReservationOptions = {
  plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
  initialView: "dayGridMonth",
  editable: false, selectable: true,
  selectMirror: true, dayMaxEvents: true, weekends: true,
  select: handleDateSelectReservation,
  droppable: false,
  headerToolbar: {
    left: "prev,next", center: "title", right: "dayGridMonth",
  },
  events: async function (fetchInfo: any, successCallback: any, failureCallback: any) {
    let list = [] as any
    loading.value = true
    widgetsReservation.value = []

    try {
      const response = await clinic.postRequest("/reservation/calendar", {
        start_date: fetchInfo.startStr,
        end_date: fetchInfo.endStr,
        clinic: clinics
      })

      if (response.status == 200 && response.data && Array.isArray(response.data)) {
        list = response.data.map((item: any) => {
          return {
            id: item.ID || item.id,
            title: ` (${item.total || 0}) ${item.status || 'Unknown'}`,
            start: new Date(item.date).toISOString(),
            allDay: true
          }
        })

        widgetsReservation.value = Object.values(response.data.reduce((acc: any, item: any) => {
          const status = item.status || 'Unknown'
          if (!acc[status]) {
            acc[status] = {
              class: "success",
              svg1: "rate",
              svg2: "halfcircle",
              number: 0,
              title: status,
              font: "font-success",
              icon: "icon-arrow-up",
              total: "+70%"
            };
          }
          acc[status].number += item.total || 0;
          return acc;
        }, {}));
      }
    } catch (error) {
      console.error('Error fetching reservation calendar data:', error)
      failureCallback(error)
    }

    loading.value = false
    successCallback(list);
  }
}

async function fetchReservations() {
  listReservation.value = []
  loading.value = true
  await clinic.postRequest("/reservation/list", { page: 1, size: 10000, date: daySelectedReservation.value, clinic: session.getUser().clinic }).then((res) => {
    if (res.status == 200 && res.data) {
      listReservation.value = res.data
    }
  })
  loading.value = false
}

async function fetchRegistrations() {
  listRegistration.value = []
  loading.value = true
  await clinic.postRequest("/registration/list", { page: 1, size: 10000, date: daySelectedRegistration.value, clinic: session.getUser().clinic }).then((res) => {
    if (res.status == 200 && res.data) {
      listRegistration.value = res.data
    }
  })
  loading.value = false
}

function handleDateSelectReservation(selectInfo: any) {
  daySelectedReservation.value = selectInfo.startStr
  lastSelectedInfoReservation.value = selectInfo;
  fetchReservations()
}

function handleDateSelectRegistration(selectInfo: any) {
  daySelectedRegistration.value = selectInfo.startStr
  lastSelectedInfoRegistration.value = selectInfo;
  fetchRegistrations()
}

import { Modal } from 'bootstrap'
const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly

// Watcher untuk activeTab untuk memastikan sinkronisasi data
watch(activeTab, (newTab) => {
  console.log('Active tab watcher triggered:', newTab)
  nextTick(() => {
    // Delay untuk memastikan DOM sudah terupdate
    setTimeout(() => {
      if (newTab === 'reservation' && fullCalendarReservation.value) {
        console.log('Watcher: Refetching reservation calendar')
        fullCalendarReservation.value.getApi().refetchEvents()
      } else if (newTab === 'registration' && fullCalendarRegistration.value) {
        console.log('Watcher: Refetching registration calendar')
        fullCalendarRegistration.value.getApi().refetchEvents()
      }
    }, 100)
  })
})

onMounted(() => {
  // Inisialisasi modal jika perlu
  if (modalRef.value) {
    bsModal = new Modal(modalRef.value)
  }
  
  // Pastikan kedua kalender dimuat saat halaman pertama kali dibuka
  nextTick(() => {
    // Delay untuk memastikan DOM sudah ter-render dengan baik
    setTimeout(() => {
      console.log('onMounted: Loading both calendars')
      
      // Trigger initial load untuk kalender reservation (tab aktif)
      if (fullCalendarReservation.value) {
        console.log('onMounted: Loading reservation calendar')
        fullCalendarReservation.value.getApi().refetchEvents()
      }
      
      // Trigger initial load untuk kalender registration (meskipun tidak aktif)
      if (fullCalendarRegistration.value) {
        console.log('onMounted: Loading registration calendar')
        fullCalendarRegistration.value.getApi().refetchEvents()
      }
    }, 500) // Delay 500ms untuk memastikan DOM sudah siap
  })
})

const closeModal = () => {
  if (bsModal) { // Check if bsModal is initialized
    bsModal.hide()
  }
}
</script>
